import * as React from 'react';
import { Pressable, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Card, Text } from '@/ui';

interface AutopilotCardItemProps {
  title: string;
  body?: string;
  cost: string;
  unit: string;
  style?: any;
  disabled?: boolean;
  active?: boolean;
  onPress?: () => void;
}

export const AutopilotCardItem = ({
  title,
  body,
  cost,
  unit,
  style,
  disabled = false,
  active = false,
  onPress,
}: AutopilotCardItemProps) => {
  const { styles, theme } = useStyles(stylesheet);
  const [hover, setHover] = React.useState(false);

  const getStyle = () => {
    const showDisabled = disabled;
    let stateStyle = styles.default;

    if (hover) {
      stateStyle = styles.hover;
    }
    if (active) {
      stateStyle = styles.active;
    }
    if (showDisabled) {
      stateStyle = styles.disabled;
    }

    return [stateStyle];
  };

  return (
    <Pressable
      style={[styles.container, style]}
      onHoverIn={() => setHover(true)}
      onHoverOut={() => setHover(false)}
      hitSlop={8}
      onPress={() => {
        onPress?.();
      }}
    >
      <Card style={[styles.card, getStyle()]}>
        <View style={styles.cardContentContainer}>
          <Text type="bodyBold">{title}</Text>

          {body ? (
            <Text
              type="caption1"
              style={{ color: theme.colors.text.secondary }}
            >
              Vehicle recognizes stop signs and traffic lights. Note that FSD
              still requires hands on the wheel at all times.
            </Text>
          ) : null}
        </View>

        <View style={{ flexDirection: 'row', alignItems: 'flex-end', gap: 4 }}>
          <Text type="bodyBold">{cost}</Text>

          <Text type="caption1" style={{ color: theme.colors.text.secondary }}>
            {unit}
          </Text>
        </View>
      </Card>
    </Pressable>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    width: '100%',
    gap: 8,
  },
  card: {
    flexGrow: 1,
    flexDirection: {
      xs: 'row',
      md: 'column',
    },
    justifyContent: 'space-between',
    alignItems: {
      xs: 'center',
      md: 'flex-start',
    },
    padding: 16,
    gap: 8,
  },
  cardContentContainer: {
    width: {
      xs: '60%',
      md: '100%',
    },
    gap: 4,
  },
  default: {
    backgroundColor: theme.colors.card.default.backgroundColor,
    borderColor: theme.colors.card.default.borderColor,
  },
  active: {
    backgroundColor: theme.colors.card.active.backgroundColor,
    borderColor: theme.colors.card.active.borderColor,
    borderWidth: 1,
  },
  hover: {
    backgroundColor: theme.colors.card.hover.backgroundColor,
    borderColor: theme.colors.card.hover.borderColor,
  },
  disabled: {
    backgroundColor: theme.colors.card.disabled.backgroundColor,
    borderColor: theme.colors.card.disabled.borderColor,
    opacity: 0.4,
  },
}));
